import React, { useEffect, useState, useRef, Dispatch, SetStateAction } from "react";
import styled from 'styled-components'
import { NavLink } from "react-router-dom";
import { COLOR_BLACK_BORDER, COLOR_BLUE, COLOR_GREEN, COLOR_WHITE } from '../constants/colors';
import { ADMINISTRATEUR, FRAIS, MANDAT, CONTACT, DEVENIR_PARTENAIRE, DEVIS, OFFRES, HOME } from '../constants/menu';
import getWindowSize from "../utils/windowSize";
import logo from '../assets/logo.svg'
import burger from '../assets/burger.svg'

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 auto;
  width: 95%;

  transition: all 0.3s ease;
  @media screen and (max-width: 900px) {
    flex-direction: column;
  }
  
  * {
    box-sizing: border-box;
  }

  #btn-open-mobile {
    cursor: pointer;
    position: absolute;
    left: 30px;
    top: 50%;
    transform: translateY(-50%);
    visibility: hidden;
    opacity: 0;
    transition: 2s ease all;
    width: 32px;
    height: 32px;
    img  {
      width: 32px;
      height: 32px;
      vertical-align: middle;
      border-style: none;
    }
  }

  @media screen and (max-width: 900px) {
    #btn-open-mobile{
      visibility: visible;
      opacity: 1;
      z-index: 2;
    }
  }
`
const Logo = styled.a`
  height: 75px;
  padding-top: 7px;

  img {
    border-style: none;
    vertical-align: middle;
    height: 60px;
    font-weight: 400;
  }
  @media screen and (max-width: 900px) {
    #btn-open-mobile{
      visibility: visible;
      opacity: 1;
    }
  }
`

const Hidden = styled.div`
  flex: 1;
  display: block;
`

const Menu = styled.div`
  &.computer {
    display: block;
    * {
      box-sizing: border-box;
    }
  }
  .flex-1 {
    flex: 1;
  }
`


export const StyledNavLink = styled(NavLink)`
  font-style: normal;
  margin: 0 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: ${COLOR_BLUE};
  text-decoration: none;
  font-weight: bold;
  font-size: 16px;

  :hover {
    color: ${COLOR_GREEN};
  }

  &.active{
    color: ${COLOR_GREEN};
  }

  @media screen and (max-width: 900px) {
    padding: 10px;
  }
  /*@media screen and (max-width: 1300px) {
    margin: 0 6px;
    font-size: 14px;
  }*/
`;

export const StyledNavLinkHref = styled.a`
  font-style: normal;
  margin: 0 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: ${COLOR_BLUE};
  text-decoration: none;
  font-weight: bold;
  font-size: 16px;

  :hover {
    color: ${COLOR_GREEN};
  }

  &.active{
    color: ${COLOR_GREEN};
  }

  @media screen and (max-width: 900px) {
    padding: 10px;
  }
  /*@media screen and (max-width: 1300px) {
    margin: 0 6px;
    font-size: 14px;
  }*/
`;

const Item = styled.a`
  font-style: normal;
  margin: 0 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: ${COLOR_BLUE};
  text-decoration: none;
  font-weight: bold;
  font-size: 16px;

  :hover {
    color: ${COLOR_GREEN};
  }

  a:active{
    color: ${COLOR_GREEN};
  }

  @media screen and (max-width: 900px) {
    padding: 10px;
  }
  /*@media screen and (max-width: 1300px) {
    margin: 0 6px;
    font-size: 14px;
  }*/
`


const FAQ = styled.div`
  display: inline-block;
  position: relative;

  font-style: normal;
  margin: 0 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: ${COLOR_BLUE};
  text-decoration: none;
  font-weight: bold;
  font-size: 14px;
  :hover {
    color: ${COLOR_GREEN};
  }
  @media screen and (max-width: 900px) {
    padding: 10px;
  }
  @media screen and (max-width: 1300px) {
    margin: 0 6px;
    font-size: 14px;
  }  

  .sub-menu {
    position: absolute;
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    visibility: hidden;
    opacity: 0;
    transition: opacity 750ms;
  }

  .arrow {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #222222c0;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 10px;
  }

  .content {
    display: flex;
    flex-direction: column;
    margin-top: 16px;
    box-shadow: 0px 2px 5px rgb(0 0 0 / 50%);
    border-radius: 10px;
    background-color: ${COLOR_WHITE};
    visibility: hidden;
    opacity: 0;
    a {
      display: block;
      cursor: pointer;
      font-style: normal;
      font-size: 14px;
      font-weight: bold;
      color: ${COLOR_BLUE};
      text-decoration: none;
      padding: 0 24px;
      margin: 0 6px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      white-space: nowrap;
      border-bottom: 1px solid ${COLOR_BLACK_BORDER};
      transition: all 0.3s ease;
    }
    a:hover {
      color: ${COLOR_GREEN};
    }
  }

  :hover {
    .sub-menu, .content {
      visibility: visible;
      opacity: 1;
    }
    color: ${COLOR_GREEN};
  }
`

const MenuNavigation = ({burgerOpen, _setBurgerOpen, menuHeight, _setMenuHeight} : {burgerOpen : boolean, _setBurgerOpen: Dispatch<SetStateAction<boolean>>, menuHeight : number, _setMenuHeight : Dispatch<SetStateAction<number>>}) => {
  
  const [ windowSize, _setWindowSize ] = useState<{innerWidth: number, innerHeight: number}>(getWindowSize())
  const [ reduce, _setReduce ] = useState<boolean>(false)
  const ref = useRef<HTMLInputElement>() as React.MutableRefObject<HTMLInputElement>

  const getComponentHeight = () => {
    if (ref.current)
      _setMenuHeight(ref.current.offsetHeight)
  }
  
  useEffect(() => {
    const handleSize = () => {
      _setWindowSize(getWindowSize())
    }
    window.addEventListener('resize', handleSize)
    return () => {
      window.removeEventListener('resize', handleSize)
    }
  }, [])

  useEffect(() => {
    if (windowSize.innerWidth > 900) {
      _setReduce(false)
      _setBurgerOpen(false)
    }
    else
      _setReduce(true)
  }, [_setWindowSize, reduce, _setReduce, windowSize, _setBurgerOpen])

  useEffect(() => {
    window.addEventListener("resize", getComponentHeight)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Wrapper ref={ref}>
      <div id="btn-open-mobile">
        <img src={burger} alt='burger-button' onClick={() => _setBurgerOpen(!burgerOpen)}/>
      </div>
      <Logo href={HOME} >
        <img src={logo} alt='site_logo'/>
      </Logo>
      <Hidden></Hidden>
      <Menu 
        className={
          (windowSize.innerWidth > 900) ? 'computer' : (burgerOpen ? 'mobile active' : 'mobile')
        }
      >
      {( 
        !reduce &&
        <>
          <Item
            href={HOME}
          >
            Accueil
          </Item>
          <Item
            href={OFFRES}
          >
            Nos offres
          </Item>
          <StyledNavLink
            to={'/location-vente'}
          >
            Location / Vente
          </StyledNavLink>
          <Item
            href={DEVIS}
          >
            Confier mon bien / Devis en ligne
          </Item>          
          <Item 
            href={DEVENIR_PARTENAIRE}
          >
            Devenir Partenaire
          </Item>
          <FAQ>
            FAQ
            <div className="sub-menu">
              <div className="arrow"></div>
              <div className="content">
                <Item
                  href={MANDAT}
                  //className={({ isActive }) => (isActive ? 'active' : 'inactive')}  
                >
                  Mandat de gestion locative
                </Item>
                <Item
                  href={FRAIS}
                  //className={({ isActive }) => (isActive ? 'active' : 'inactive')}
                >
                  Frais de gestion locative
                </Item>
                <Item
                  href={ADMINISTRATEUR}
                  //className={({ isActive }) => (isActive ? 'active' : 'inactive')}
                >
                  Administrateur de biens
                </Item>
              </div>
            </div>
          </FAQ>
          <Item
            href={CONTACT}
            //className={({ isActive }) => (isActive ? 'active' : 'inactive')}
          >
            Nous contacter
          </Item>
        </>
      )}
      </Menu>
    </Wrapper>
  )
}

export default MenuNavigation;